// types.ts
export enum ApplicationFormModals {
  SUBMITTING_CANDIDATE = 'submitting-candidate',
}
